import { createIcon } from '../createIcon';

export const QuoteLeftIconConfig = {
  name: 'QuoteLeftIcon',
  height: 512,
  width: 512,
  svgPath: 'M464 256h-80v-64c0-35.3 28.7-64 64-64h8c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24h-8c-88.4 0-160 71.6-160 160v240c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48zm-288 0H96v-64c0-35.3 28.7-64 64-64h8c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24h-8C71.6 32 0 103.6 0 192v240c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48z',
  yOffset: 0,
  xOffset: 0,
  transform: ''
};

export const QuoteLeftIcon = createIcon(QuoteLeftIconConfig);

export default QuoteLeftIcon;